// extracted by mini-css-extract-plugin
export default {"title":"FinancialAid_title__7r1ot","screenWrap":"FinancialAid_screenWrap__zYEwa","expandedSidebar":"FinancialAid_expandedSidebar__E9fVl","hidden":"FinancialAid_hidden__KOcst"};